<script setup lang="ts">
import type { UserGroup } from '@/services/user_groups';

import EmptyState from './EmptyState.vue';
import UserGroupCard from './UserGroupCard.vue';

interface Props {
    groups: UserGroup[];
    disabled?: boolean;
}

interface Emits {
    (e: 'create-group'): void;
    (e: 'edit-group', group: UserGroup): void;
    (e: 'delete-group', group: UserGroup): void;
    (e: 'manage-members', group: UserGroup): void;
    (e: 'view-members', group: UserGroup): void;
    (e: 'view-azure-groups'): void;
}

defineProps<Props>();
defineEmits<Emits>();
</script>

<template>
    <EmptyState
        v-if="groups.length === 0"
        @create-group="$emit('create-group')"
        @view-azure-groups="$emit('view-azure-groups')"
    />

    <div v-else class="flex flex-col gap-4 pb-8">
        <UserGroupCard
            v-for="group in groups"
            :key="group.id"
            :group="group"
            :disabled="disabled"
            @edit="$emit('edit-group', $event)"
            @delete="$emit('delete-group', $event)"
            @manage-members="$emit('manage-members', $event)"
            @view-members="$emit('view-members', $event)"
        />
    </div>
</template>
